<script setup>
    // Layout for /sunset, the notice shown inside the native app shells.
    //
    // Modelled on `bare` rather than `default` for the same reason /offline is:
    // the default/iframe/archives layouts spin up ~10 Pinia stores and fire
    // fetches from setup()/onMounted. None of that is wanted here — this page
    // exists to tell someone the app is finished and send them to the web, so it
    // must render on its own with no data, no nav and no bottom bar.
    //
    // A separate layout from `bare` because `bare` sets its own "Offline" head.
    import { updateHead } from '@/composables/helpers/updateHead';

    // updateHead emits `og:image` as `page.image || ''`, so omitting it does not
    // fall back to anything — it ships an EMPTY og:image and the page previews
    // with no artwork. This layout is what every retired iOS install lands on,
    // so it is shareable in practice.
    const frontEnd = useRuntimeConfig().public.clientFrontend;

    updateHead({
        title: 'Chicago Architecture Center',
        description: 'This app is no longer being updated. Visit architecture.org.',
        path: useRoute().path,
        image: frontEnd + '/img/ohc-share.jpg',
    });
</script>

<template>
    <div id="main" class="sunset-layout">
        <NuxtPage />
    </div>
</template>

<style lang="scss">
    @use '@/assets/styles/main.scss';

    // layouts/default.vue carries an UNSCOPED `#main { margin-top:
    // var(--sticky-bar-height) }` so its content clears the fixed header. That
    // rule ships in the global bundle, so it lands here too — on a layout that
    // has no header at all. The result was the notice pushed 111px down the page
    // (59px header + 52px chip bar) and the document scrolling by exactly that,
    // which is why it would not centre.
    //
    // One id plus one class outranks the bare id, so this wins without !important.
    #main.sunset-layout {
        margin-top: 0;
    }
</style>
